import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserRole } from 'user/model/user-role';
import { user } from 'user/model/user.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { UserOutput } from '../model/user.output';

export interface CreateUserInput {
	readonly emailAddress: string;
	readonly firstName: string;
	readonly lastName: string;
	readonly language: string;
	readonly organizationId: string;
	readonly phoneNumber: string;
	readonly role: UserRole;
	readonly welcomeMessage: string;
	readonly coachId: string;
}

export interface CreateUserParams {
	input: CreateUserInput;
}

@Injectable({ providedIn: 'root' })
export class CreateUserApiMutation extends ApiMutation<
	UserOutput,
	CreateUserParams
> {
	client = 'iam';
	document = gql`
		mutation CreateUser($input: CreateUserInput!) {
			createUser(input: $input) {
				...User
			}
		}
		${user}
	`;
	method = 'createUser';
}
